export type Choice = { value: string | number; label: string };

/** Visible options keep the current choice, and the choices beside it, easy to find. */
export function choiceControl(options: {
  id: string;
  label: string;
  value: string | number;
  choices: Choice[];
  hint?: string;
  onChange?: (value: string) => void;
}): HTMLFieldSetElement {
  const field = document.createElement('fieldset');
  field.className = 'choice-row';
  field.dataset.choice = options.id;
  const legend = document.createElement('legend');
  legend.textContent = options.label;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.id = options.id;
  input.value = String(options.value);
  const row = document.createElement('div');
  row.className = 'choice-options';
  for (const choice of options.choices) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'choice-option';
    button.id = `${options.id}-${choice.value}`;
    button.dataset.choiceValue = String(choice.value);
    button.textContent = choice.label;
    button.setAttribute('aria-pressed', String(input.value === String(choice.value)));
    button.addEventListener('click', () => {
      input.value = String(choice.value);
      for (const sibling of row.querySelectorAll<HTMLButtonElement>('button')) {
        sibling.setAttribute('aria-pressed', String(sibling === button));
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      options.onChange?.(input.value);
    });
    row.append(button);
  }
  field.append(legend, input, row);
  if (options.hint) {
    const hint = document.createElement('p');
    hint.className = 'dim choice-hint';
    hint.textContent = options.hint;
    field.append(hint);
  }
  return field;
}

export function nextChoiceIndex(index: number, count: number, delta: number): number {
  return count > 0 ? ((index + delta) % count + count) % count : -1;
}
